// Palette root-level filter for DndPaletteComponent. Kept OUT of
// dnd_node_controller, whose lifecycle is per-item (drag payload + keyboard
// add bring-up) — the filter lives on the palette root and manages section
// visibility, so a dedicated root controller keeps each controller to one
// responsibility and stays trivially testable.
import { Controller } from "@hotwired/stimulus"

// Native <input type="search"> at the palette top (dnd_palette_component's
// erb) filters items client-side by label text OR their section heading
// text — case-insensitive, live on `input`. A section wrapper with zero
// visible items hides entirely (heading order / ungrouped-last preserved).
// Clearing the query restores full visibility (removing the input element
// only restores it once filter() runs again — input events die with it).
export default class extends Controller {
  // `input` = the search field; `group` = each section wrapper; `item` and
  // `heading` nested inside (item = a palette item, heading = its section's
  // optional heading element).
  static targets = ["input", "group", "item", "heading"]

  // Wired via data-action on the input itself (`input->...#filter`) so the
  // action attribute is the single source of wiring — deleting it breaks
  // filtering, which the __tests__/roadmap_palette_filter pin relies on.
  filter() {
    const query = this.hasInputTarget ? this.inputTarget.value.trim().toLowerCase() : ""

    for (const group of this.groupTargets) {
      const heading = group.querySelector("[data-ui--flow-dnd-palette-filter-target='heading']")
      const headingText = heading ? heading.textContent.toLowerCase() : ""
      const items = group.querySelectorAll("[data-ui--flow-dnd-palette-filter-target='item']")

      let visible = 0
      for (const item of items) {
        const match = !query
          || item.textContent.toLowerCase().includes(query)
          || headingText.includes(query)
        item.style.display = match ? "" : "none"
        if (match) visible += 1
      }

      group.style.display = visible > 0 ? "" : "none"
    }
  }
}
